import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e20eca80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"max-width":"500px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select the Sprinklr Environment on which your account is hosted:", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "p-5 d-flex align-items-center justify-content-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-fw fa-2x" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Add Sprinklr Account",
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'external-systems' })))
  }, {
    default: _withCtx(() => [
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.environments, (env, envIdx) => {
              return (_openBlock(), _createElementBlock("button", {
                key: envIdx,
                class: _normalizeClass(['btn', 'btn-primary', 'me-2', 'mb-2', 'btn-env']),
                onClick: _withModifiers(($event: any) => (_ctx.openSprinklr(env)), ["stop","prevent"])
              }, _toDisplayString(env.name), 9, _hoisted_3))
            }), 128)),
            (_ctx.selectedEnvironment)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openSprinklr()))
                }, "Start authentication on " + _toDisplayString(_ctx.selectedEnvironment), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
    ]),
    _: 1
  }))
}